export default __webpack_public_path__ + "1f4fd9a64e7aaf6043906013a9bde56d.png";